import React from 'react';
import PropTypes from 'prop-types';
import {
  FaFileAlt,
  FaFileWord,
  FaFileExcel,
  FaFilePowerpoint,
  FaFileArchive,
  FaFileCode,
  FaFilePdf,
  FaFileImage,
  FaFileAudio,
  FaFileVideo,
} from 'react-icons/fa';
import '../../style/components/FileIcon.scss';

const MimeIcon = ({ mime }) => {
  if (mime) {
    const parts = mime.toLowerCase().split('/');
    switch (parts[0]) {
      case 'text':
        if (parts.length === 1) return <FaFileAlt className="file-icon" />;
        switch (parts[1]) {
          case 'html':
          case 'javascript':
          case 'css':
            return <FaFileCode className="file-icon" />;
          default:
            return <FaFileAlt className="file-icon" />;
        }
      case 'application':
        if (parts.length === 1) return 'fa fa-file-o fa-fw';
        if (parts[1].indexOf('json') >= 0) return <FaFileCode className="file-icon" />;
        if (parts[1].indexOf('pdf') >= 0) return <FaFilePdf className="file-icon text-danger" />;
        if (parts[1].indexOf('word') >= 0) return <FaFileWord className="file-icon word" />;
        if (parts[1].indexOf('excel') >= 0) return <FaFileExcel className="file-icon excel" />;
        if (parts[1].indexOf('spreadsheet') >= 0)
          return <FaFileExcel className="file-icon excel" />;
        if (parts[1].indexOf('powerpoint') >= 0)
          return <FaFilePowerpoint className="file-icon powerpoint" />;
        if (parts[1].indexOf('zip') >= 0) return <FaFileArchive className="file-icon" />;
        if (parts[1].indexOf('rar') >= 0) return <FaFileArchive className="file-icon" />;
        if (parts[1].indexOf('compressed') >= 0) return <FaFileArchive className="file-icon" />;
        if (parts[1].indexOf('xml') >= 0) return <FaFileCode className="file-icon" />;
        break;
      case 'image':
        return <FaFileImage className="file-icon" />;
      case 'audio':
        return <FaFileAudio className="file-icon" />;
      case 'video':
        return <FaFileVideo className="file-icon" />;
      default:
        return <FaFileAlt className="file-icon" />;
    }
  }

  return <FaFileAlt className="file-icon" />;
};
MimeIcon.propTypes = {
  mime: PropTypes.string,
};
MimeIcon.defaultProps = {
  mime: null,
};

export default MimeIcon;
